require('../insuranceRequestPlans/insuranceRequestPlans.scss');
require('./insuranceRequestPlansCC.override.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const className = require('classnames');

// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const OKCarousel = require('components/commons/OKCarousel/OKCarousel');

// @ constants
const { COVERAGES, COVERAGES_CONFIGURABLE, PLANS, PAYMENT_TYPE, VALUE_TYPES } = require('../../insuranceConstants/insuranceRequestHome');
const { SECOND_STEP, FOURTH_STEP } = require('constants/index');
const PLANS_ORDERED = [PLANS.BASIC, PLANS.MEDIUM, PLANS.HIGH];

// @ components
const InsuranceRequestPlansApplyButton = require('./insuranceRequestPlansComponentsCC/insuranceRequestPlansApplyButtonCC')
const InsuranceRequestPlansHeader = require('./insuranceRequestPlansComponentsCC/insuranceRequestPlansHeaderCC')
const InsuranceRequestPlansHeaderCell = require('./insuranceRequestPlansComponentsCC/insuranceRequestPlansHeaderCellCC')
const InsuranceRequestPlansRowValue = require('./insuranceRequestPlansComponentsCC/insuranceRequestPlansRowValueCC')

class InsuranceRequestPlans extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeColumn: 0,
            allColumnsDisabled: true,
            showDetailsModal: false,
        };

        this.handleActivePlanOnTable = this.handleActivePlanOnTable.bind(this);
        this.handleHoverColumn = this.handleHoverColumn.bind(this);
        this.handleClickSelectPlan = this.handleClickSelectPlan.bind(this);
        this.handleClickSelectPlanRelated = this.handleClickSelectPlanRelated.bind(this);
        this.handleToggleDetailsModal = this.handleToggleDetailsModal.bind(this);
        this.isColumnDisabled = this.isColumnDisabled.bind(this);
    }

    componentDidMount() {
        this.handleActivePlanOnTable();
    }

    handleHoverColumn(evt) {
        const cell = evt.currentTarget;
        const columnIdx = cell && cell.cellIndex ? cell.cellIndex - 1 : 0;

        this.setState({
            activeColumn: columnIdx,
            allColumnsDisabled: false,
            selected: false,
        });
    }

    handleActivePlanOnTable() {
        const { immInsuranceWizardStep } = this.props;
        const selectedPlan = immInsuranceWizardStep.get('insurancePlan');

        if (selectedPlan) {
            this.setState({
                activeColumn: PLANS_ORDERED.indexOf(selectedPlan)
            });
        }
    }

    handleToggleDetailsModal(evt) {
        const { onChangeShowCoverageDetailTable } = this.props;
        evt && evt.preventDefault();
        onChangeShowCoverageDetailTable()
    }

    handleClickSelectPlan(evt, plan) {
        evt.preventDefault();

        const { insuranceSelectPlan, setData, recordEventSelectPlan } = this.props;

        recordEventSelectPlan(plan);

        insuranceSelectPlan(plan).then(() => {
            this.setState({ selected: true });

            setData(SECOND_STEP, {
                simulationChanged: false
            });
            setData(FOURTH_STEP, {
                paymentType: PAYMENT_TYPE.ANNUAL
            });
        });
    }

    handleClickSelectPlanRelated(plan) {
        const { selectPlanInRelatedWizardStep3, setData, recordEventSelectPlan } = this.props;

        recordEventSelectPlan(plan);

        selectPlanInRelatedWizardStep3(plan);
        setData(FOURTH_STEP, {
            paymentType: PAYMENT_TYPE.ANNUAL
        });
    }

    buildShowRowTooltip(label) {
        return (
            <OKTooltip
                content={label}
                offset={[0, -15]}
            />
        );
    }

    getClassNameForTableCell(coverage) {
        const { webActuationLimitsIsEnabled } = this.props;

        const coverageConfigurable = COVERAGES_CONFIGURABLE[coverage];
        const isCoverageConfigurable = coverageConfigurable ? true : false;

        return className('coverage-and-plans__table-category', {
            'coverage-and-plans__table-category-configurable': isCoverageConfigurable && webActuationLimitsIsEnabled,
        });
    }

    buildCarouselCoverageRow(coveragePlan, key) {
        const {
            immInsuranceWizardStep,
            insuranceUsabilityImprovementsFlag,
            isRelated,
            onhandleChangeSelectedPlanInStateComponent
        } = this.props;

        const coverageGetPlanData = immInsuranceWizardStep.getIn(['coveragesAndPlansData', coveragePlan]).toJS();
        const coverageDataRow = coverageGetPlanData.map((item, idx) => {
            const camelCaseItemName = item.name.toLowerCase();
            const categoryName = formatText(`insuranceRequestHome-step3${camelCaseItemName}`);
            const fireStoleValidation = camelCaseItemName === 'fires' || camelCaseItemName === 'stole';
            const brokenGlassWaterDamageValidation = camelCaseItemName === 'broken_glass' || camelCaseItemName === 'water_damage';
            const tableCellClass = this.getClassNameForTableCell(item.name);

            let rowTooltip = null;

            if (fireStoleValidation || brokenGlassWaterDamageValidation) {
                rowTooltip = this.buildShowRowTooltip(`insuranceRequestHome-step3${camelCaseItemName}Tooltip`);
            }

            return (
                <tbody key={idx} className="coverage-and-plans__main-row">
                    <OKTableRow className="coverage-and-plans__table-row-carousel">
                        <OKTableCell className={tableCellClass}>
                            {categoryName}
                            {rowTooltip}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow className="coverage-and-plans__table-row-carousel">
                        <OKTableCell className="coverage-and-plans__table-category">
                            <InsuranceRequestPlansRowValue
                                insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                                type={item.type}
                                value={item.value}
                            />
                        </OKTableCell>
                    </OKTableRow>
                </tbody>
            );
        });
        const selectingAPlan = isRelated ? this.handleClickSelectPlanRelated : this.handleClickSelectPlan;
        const coveragesTable = (
            <div key={key}>
                <table>
                    <thead>
                        <tr>
                            <OKTableCell
                                className="coverage-and-plans__table-cell-header coverage-and-plans__table-cell-header--title"
                                asHeader={true}
                            >
                                <div className="coverage-and-plans__table-cell-title">
                                    {formatText('insuranceRequestHome-step3CoveragesAndGuaranteesTableTitle')}
                                    <a className="buttons-base buttons-base--additional-action-primary coverage-and-plans__link" onClick={this.handleToggleDetailsModal}>
                                        {formatText('insuranceRequestHome-step3ViewDetailLink')}
                                    </a>
                                </div>
                            </OKTableCell>
                        </tr>
                        <tr className="coverage-and-plans__table-row-carousel">
                            <InsuranceRequestPlansHeaderCell
                                column={0}
                                immInsuranceWizardStep={immInsuranceWizardStep}
                                insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                                isColumnDisabled={this.isColumnDisabled}
                                onHandleHoverColumn={this.handleHoverColumn}
                                plan={coveragePlan}
                            />
                        </tr>
                    </thead>
                    {coverageDataRow}
                    <tbody>
                        <OKTableRow className="coverage-and-plans__table-row">
                            {
                                InsuranceRequestPlansApplyButton(
                                    coveragePlan,
                                    key,
                                    immInsuranceWizardStep,
                                    this.isColumnDisabled,
                                    this.handleHoverColumn,
                                    selectingAPlan,
                                    isRelated,
                                    onhandleChangeSelectedPlanInStateComponent
                                )
                            }
                        </OKTableRow>
                    </tbody>
                </table>
            </div>
        );

        return coveragesTable;
    }

    buildCarouselTableBlocks() {
        return PLANS_ORDERED.map((planKey, idx) => this.buildCarouselCoverageRow(planKey, idx));
    }

    buildCivilLiabilityValue(coverageItem, coveragePlan, OldBaseValue, coverageItemName) {
        const {
            insuranceUsabilityImprovementsFlag
        } = this.props;

        const coverageRowValueFather = (
            <InsuranceRequestPlansRowValue
                insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                type={coverageItem.get('type')}
                value={coverageItem.get('value')}
                valueOld={OldBaseValue}
            />
        );
        const covarageItemChildren = coveragePlan.find(item => item.get('name') === coverageItemName).getIn(['children', 0]);
        const coverageType = VALUE_TYPES.DOGS;
        const coverageRowValueChildren = (
            <InsuranceRequestPlansRowValue
                insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                type={coverageType}
                value={covarageItemChildren.get('value')}
            />
        );

        return (
            <table className="coverage-and-plans__table-category-configurable-table">
                <tr className="coverage-and-plans__table-category-configurable-table-row
                    coverage-and-plans__table-category-configurable-table-row-center">
                    <td>
                        {coverageRowValueFather}
                    </td>
                </tr>
                <tr className="coverage-and-plans__table-category-configurable-table-row
                    coverage-and-plans__table-category-configurable-table-row-center">
                    <td>
                        {coverageRowValueChildren}
                    </td>
                </tr>
            </table>
        );
    }

    buildChildrenStoleValue(covarageItemChildren) {
        const { insuranceUsabilityImprovementsFlag } = this.props;
        let childrenStoleValue;

        if (covarageItemChildren.get('changed')) {
            childrenStoleValue = (
                <InsuranceRequestPlansRowValue
                    insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                    type={covarageItemChildren.get('type')}
                    value={covarageItemChildren.get('value')}
                    valueOld={covarageItemChildren.get('defaultValue')}
                />
            );
        } else {
            childrenStoleValue = (
                <InsuranceRequestPlansRowValue
                    insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                    type={covarageItemChildren.get('type')}
                    value={covarageItemChildren.get('value')}
                />
            );
        }

        return childrenStoleValue;
    }

    buildStoleValue(coverageItem, coveragePlan, coverageItemOld, coverageItemName) {
        const { insuranceUsabilityImprovementsFlag } = this.props;
        const coverageRowValueFather = (
            <InsuranceRequestPlansRowValue
                insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                type={coverageItem.get('type')}
                value={coverageItem.get('value')}
                valueOld={coverageItemOld.get('baseValue')}
            />
        )

        const coverageChildren = coveragePlan.find(item => item.get('name') === coverageItemName).get('children');
        const impairmentsHousing = coverageChildren.find(item => item.get('name') === COVERAGES.IMPAIRMENTS_HOUSING);
        const impairmentsHousingRowValue = impairmentsHousing.get('visible') ? this.buildChildrenStoleValue(impairmentsHousing) : null;
        const theftMoney = coverageChildren.find(item => item.get('name') === COVERAGES.THEFT_MONEY);
        const theftMoneyRowValue = theftMoney.get('visible') ? this.buildChildrenStoleValue(theftMoney) : null;

        return (
            <table className="coverage-and-plans__table-category-configurable-table">
                <tr className="coverage-and-plans__table-category-configurable-table-row
                    coverage-and-plans__table-category-configurable-table-row-center">
                    <td>
                        {coverageRowValueFather}
                    </td>
                </tr>
                {
                    impairmentsHousing.get('visible') ?
                        <tr className="coverage-and-plans__table-category-configurable-table-row
                            coverage-and-plans__table-category-configurable-table-row-center">
                            <td>
                                {impairmentsHousingRowValue}
                            </td>
                        </tr>
                        : null
                }
                {
                    theftMoney.get('visible') ?
                        <tr className="coverage-and-plans__table-category-configurable-table-row
                            coverage-and-plans__table-category-configurable-table-row-center">
                            <td>
                                {theftMoneyRowValue}
                            </td>
                        </tr>
                        : null
                }
            </table>
        );
    }

    validateShowChildren(coveragePlan, coverageItemName) {
        let isShowChildren = false;

        if (coverageItemName === COVERAGES.CIVIL_LIABILITY) {
            isShowChildren = coveragePlan.find(item => item.get('name') === coverageItemName).getIn(['children', 0]);
        } else if (coverageItemName === COVERAGES.STOLE) {
            const coverageChildren = coveragePlan.find(item => item.get('name') === coverageItemName).get('children');
            const impairmentsHousing = coverageChildren.find(item => item.get('name') === COVERAGES.IMPAIRMENTS_HOUSING);
            const theftMoney = coverageChildren.find(item => item.get('name') === COVERAGES.THEFT_MONEY);
            isShowChildren = theftMoney.get('visible');
            isShowChildren = !isShowChildren ? impairmentsHousing.get('visible') : isShowChildren;
        }

        return isShowChildren;
    }

    getCoveragePlanCells(immInsuranceWizardStep, coverageItemName, isQuotationDataChanged) {
        const {
            insuranceUsabilityImprovementsFlag,
            webActuationLimitsIsEnabled,
        } = this.props;

        const coveragePlanCells = PLANS_ORDERED.map((planKey, idx) => {
            const coveragePlan = immInsuranceWizardStep.getIn(['coveragesAndPlansData', planKey]);
            const coveragePlanOld = immInsuranceWizardStep.getIn(['coveragePlanDefault', planKey]);
            const coverageItemOld = coveragePlanOld ?
                coveragePlanOld.find(item => item.get('name') === coverageItemName) : null;
            const isShowChildren = webActuationLimitsIsEnabled ? this.validateShowChildren(coveragePlan, coverageItemName) : false;
            let coverageItem = coveragePlan.find(item => item.get('name') === coverageItemName);
            let coverageRowValue;
            const isVisible = coverageItem.get('visible');
            const isChanged = coverageItem.get('changed');

            if (coverageItemName === COVERAGES.CIVIL_LIABILITY && isShowChildren && isVisible) {
                const oldBaseValue = isChanged ? coverageItemOld.get('baseValue') : null;
                coverageRowValue = this.buildCivilLiabilityValue(coverageItem, coveragePlan, oldBaseValue, coverageItemName);
            } else if (isQuotationDataChanged && coverageItemName === COVERAGES.STOLE && isShowChildren && isVisible) {
                coverageRowValue = this.buildStoleValue(coverageItem, coveragePlan, coverageItemOld, coverageItemName);
            } else if (isQuotationDataChanged && isVisible && isChanged) {
                coverageRowValue = (
                    <InsuranceRequestPlansRowValue
                        insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                        type={coverageItem.get('type')}
                        value={coverageItem.get('value')}
                        valueOld={coverageItemOld.get('baseValue')}
                    />
                )
            } else {
                coverageRowValue = (
                    <InsuranceRequestPlansRowValue
                        insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                        type={coverageItem.get('type')}
                        value={coverageItem.get('value')}
                    />
                )
            }

            const coverageRowClass = className('coverage-and-plans__table-cell', {
                'coverage-and-plans__table-cell--disabled': this.isColumnDisabled(idx)
            });

            return (
                <td
                    key={idx}
                    className={coverageRowClass}
                    onMouseEnter={this.handleHoverColumn}
                >
                    {coverageRowValue}
                </td>
            );
        });

        return coveragePlanCells;
    }

    buildTableRow(tableCellClass, coverageLabel, tooltip, coveragePlanCells) {
        return (
            <OKTableRow className="coverage-and-plans__table-row">
                <td className={tableCellClass}>
                    <span className="coverage-and-plans__table-category-value">{coverageLabel}</span>
                    {tooltip}
                </td>
                {coveragePlanCells}
            </OKTableRow>
        );
    }

    buildClassNameCoverage(index) {
        const classValue = index === 0 ? 'coverage-and-plans__table-category-parent'
            : 'coverage-and-plans__table-category-children';

        return className(classValue);
    }

    getClassNameForCellChildren(type) {
        const isCellChildren = type !== 0 ? true : false;

        return className('coverage-and-plans__table-category-configurable-table-row', {
            'coverage-and-plans__table-category-configurable-table-row-children': isCellChildren,
        });
    }

    buildTableRowWithChildren(tableCellClass, coverageMultipleLabel, tooltip, coveragePlanCells) {
        return (
            <OKTableRow className="coverage-and-plans__table-row">
                <td className={tableCellClass}>
                    <table className="coverage-and-plans__table-category-configurable-table">
                        {
                            coverageMultipleLabel.map((coverageLabel, index) => {
                                const classCell = this.getClassNameForCellChildren(index);
                                return (
                                    <tr key={"row-" + index} className={classCell}>
                                        <td>
                                            <span className="coverage-and-plans__table-category-value">{coverageLabel}</span>
                                            {tooltip && index == 0 ? tooltip : null}
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </table>
                </td>
                {coveragePlanCells}
            </OKTableRow>
        );
    }

    buildCoverageLabel(coverageLabel, coverageItemName, immInsuranceWizardStep) {
        const coveragePlanBasic = immInsuranceWizardStep.getIn(['coveragesAndPlansData', PLANS.BASIC]);
        const coveragePlanMedium = immInsuranceWizardStep.getIn(['coveragesAndPlansData', PLANS.MEDIUM]);
        const coveragePlanHigh = immInsuranceWizardStep.getIn(['coveragesAndPlansData', PLANS.HIGH]);
        let coverageMultipleLabel = [
            coverageLabel
        ];

        if (coverageItemName === COVERAGES.CIVIL_LIABILITY) {
            coverageMultipleLabel.push(formatText('insuranceRequestHome-step3dangerous_dogs'));
        } else if (coverageItemName === COVERAGES.STOLE) {
            const childrenBasic = coveragePlanBasic.find(item => item.get('name') === coverageItemName).get('children');
            const childrenMedium = coveragePlanMedium.find(item => item.get('name') === coverageItemName).get('children');
            const childrenHigh = coveragePlanHigh.find(item => item.get('name') === coverageItemName).get('children');
            const showImpairmentsBasic = childrenBasic.find(item => item.get('name') === COVERAGES.IMPAIRMENTS_HOUSING).get('visible');
            const showImpairmentsMedium = childrenMedium.find(item => item.get('name') === COVERAGES.IMPAIRMENTS_HOUSING).get('visible');
            const showImpairmentsHigh = childrenHigh.find(item => item.get('name') === COVERAGES.IMPAIRMENTS_HOUSING).get('visible');
            const showTheftBasic = childrenBasic.find(item => item.get('name') === COVERAGES.THEFT_MONEY).get('visible');
            const showTheftMedium = childrenMedium.find(item => item.get('name') === COVERAGES.THEFT_MONEY).get('visible');
            const showTheftHigh = childrenHigh.find(item => item.get('name') === COVERAGES.THEFT_MONEY).get('visible');

            if (showImpairmentsBasic && showImpairmentsMedium && showImpairmentsHigh) {
                coverageMultipleLabel.push(formatText('insuranceRequestHome-step3impairments'));
            }

            if (showTheftBasic && showTheftMedium && showTheftHigh) {
                coverageMultipleLabel.push(formatText('insuranceRequestHome-step3theft_money'));
            }
        }

        return coverageMultipleLabel;
    }

    buildCoverageRow(coverageItemName, coverageLabel, showTooltip) {
        const { immInsuranceWizardStep } = this.props;
        const isQuotationDataChanged = immInsuranceWizardStep.get('isQuotationDataChanged');
        let coveragePlanCells, coverageMultipleLabel;

        coveragePlanCells = this.getCoveragePlanCells(immInsuranceWizardStep, coverageItemName, isQuotationDataChanged);

        if (coverageItemName === COVERAGES.CIVIL_LIABILITY) {
            coverageMultipleLabel = this.buildCoverageLabel(coverageLabel, coverageItemName, immInsuranceWizardStep);
        } else if (isQuotationDataChanged && coverageItemName === COVERAGES.STOLE) {
            coverageMultipleLabel = this.buildCoverageLabel(coverageLabel, coverageItemName, immInsuranceWizardStep);
        }

        const tableCellClass = this.getClassNameForTableCell(coverageItemName);
        const tooltip = showTooltip ? this.buildShowRowTooltip(showTooltip) : null;
        const tableRowRender = (coverageItemName === COVERAGES.CIVIL_LIABILITY && coverageMultipleLabel.length > 1)
            || (isQuotationDataChanged && coverageItemName === COVERAGES.STOLE)
            ? this.buildTableRowWithChildren(tableCellClass, coverageMultipleLabel, tooltip, coveragePlanCells)
            : this.buildTableRow(tableCellClass, coverageLabel, tooltip, coveragePlanCells);

        return tableRowRender;
    }

    getTitlePlansByStoleCoverage(coverageItemName) {
        const {
            immInsuranceWizardStep,
        } = this.props;

        const coveragePlanCells = PLANS_ORDERED.map((planKey) => {
            const coveragePlan = immInsuranceWizardStep.getIn(['coveragesAndPlansData', planKey]);
            const coverageItem = coveragePlan.find(item => item.get('name') === coverageItemName);
            let id = Number(coverageItem.get('value'));
            return PLANS_ORDERED[id];
        });

        return coveragePlanCells;
    }

    isColumnDisabled(column) {
        const {
            immInsuranceWizardStep,
            insuranceUsabilityImprovementsFlag,
        } = this.props;

        const selectedPlan = immInsuranceWizardStep.get('insurancePlan');

        return !insuranceUsabilityImprovementsFlag || !this.state.allColumnsDisabled || !!selectedPlan ?
            this.state.activeColumn !== column :
            false;
    }

    buildDisclaimerCoverageConfigurable() {
        const { webActuationLimitsIsEnabled } = this.props;
        const disclaimerCoverageConfigurable = <FormattedText value={'insuranceRequestPlanCC-disclaimerCoverageConfigurable'} />;

        return webActuationLimitsIsEnabled ? (
            <div className="col-sm-12 visible-md visible-lg">
                <ul className="coverage-and-plans__bullets-list">
                    <li className="coverage-and-plans__bullets-list-item">{disclaimerCoverageConfigurable}</li>
                </ul>
            </div>
        ) : null;
    }

    render() {
        const {
            immInsuranceWizardStep,
            insuranceUsabilityImprovementsFlag,
            isRelated,
            onhandleChangeSelectedPlanInStateComponent
        } = this.props;
        const context = isRelated ? 'insuranceRelatedRequest' : 'insuranceRequestHome';
        const stoleLabel = formatText('insuranceRequestHome-step3stole');
        const firesLabel = formatText('insuranceRequestHome-step3fires');
        const waterDamageLabel = formatText('insuranceRequestHome-step3water_damage');
        const brokenGlassLabel = formatText('insuranceRequestHome-step3broken_glass');
        const legalDefenseLabel = formatText('insuranceRequestHome-step3legal_defense');
        const civilLiabilityLabel = formatText('insuranceRequestHome-step3civil_liability');
        const aestheticDamageLabel = formatText('insuranceRequestHome-step3aesthetic_damage');
        const electricalDamageLabel = formatText('insuranceRequestHome-step3electrical_damage');

        const stoleTooltip = <FormattedText value={`${context}-step3stoleTooltip`} />;
        const firesTooltip = <FormattedText value="insuranceRequestHome-step3basicTooltip" />;
        const brokenGlassTooltip = <FormattedText value={"insuranceRelatedRequest-step3broken_glassTooltip"} />;
        const civilLiabilityTooltip = <FormattedText value={"insuranceRequestHome-step3civil_liabilityTooltip"} />;

        const titlePlansByStoleCoverage = this.getTitlePlansByStoleCoverage(COVERAGES.STOLE);
        const buildStoleRow = this.buildCoverageRow(COVERAGES.STOLE, stoleLabel, stoleTooltip);
        const buildFiresRow = this.buildCoverageRow(COVERAGES.FIRES, firesLabel, firesTooltip);
        const buildWaterDamageRow = this.buildCoverageRow(COVERAGES.WATER_DAMAGE, waterDamageLabel);
        const buildBrokenGlassRow = this.buildCoverageRow(COVERAGES.BROKEN_GLASS, brokenGlassLabel, brokenGlassTooltip);
        const buildLegalDefenseRow = this.buildCoverageRow(COVERAGES.LEGAL_DEFENSE, legalDefenseLabel);
        const buildCivilLiabilityRow = this.buildCoverageRow(COVERAGES.CIVIL_LIABILITY, civilLiabilityLabel, civilLiabilityTooltip);
        const buildAestheticDamageRow = this.buildCoverageRow(COVERAGES.AESTHETIC_DAMAGE, aestheticDamageLabel);
        const buildElectricalDamageRow = this.buildCoverageRow(COVERAGES.ELECTRICAL_DAMAGE, electricalDamageLabel);
        const selectingAPlan = isRelated ? this.handleClickSelectPlanRelated : this.handleClickSelectPlan;
        const buildApplyButtons = PLANS_ORDERED.map((plan, idx) => InsuranceRequestPlansApplyButton(
            plan,
            idx,
            immInsuranceWizardStep,
            this.isColumnDisabled,
            this.handleHoverColumn,
            selectingAPlan,
            isRelated,
            onhandleChangeSelectedPlanInStateComponent
        ));
        const settings = {
            className: 'coverage-and-plans__carousel',
            dots: true,
            speed: 500,
            infinite: false,
            slidesToShow: 1,
            draggable: false,
            arrows: false,
            initialSlide: 0
        };
        const coveragesAndPlansBlock = this.buildCarouselTableBlocks();

        return (
            <div className="coverage-and-plans">
                <div className="row">
                    <div className="col-sm-12 visible-md visible-lg">
                        <table
                            className="coverage-and-plans__table"
                            onMouseLeave={this.handleActivePlanOnTable}
                        >
                            <thead>
                                <InsuranceRequestPlansHeader
                                    immInsuranceWizardStep={immInsuranceWizardStep}
                                    insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                                    isColumnDisabled={this.isColumnDisabled}
                                    onHandleHoverColumn={this.handleHoverColumn}
                                    plansOrdered={PLANS_ORDERED}
                                    titlePlans={titlePlansByStoleCoverage}
                                />
                            </thead>
                            <tbody>
                                {insuranceUsabilityImprovementsFlag && buildStoleRow}
                                {buildFiresRow}
                                {buildBrokenGlassRow}
                                {buildWaterDamageRow}
                                {buildLegalDefenseRow}
                                {buildElectricalDamageRow}
                                {buildCivilLiabilityRow}
                                {buildAestheticDamageRow}
                                {!insuranceUsabilityImprovementsFlag && buildStoleRow}
                                <OKTableRow className="coverage-and-plans__table-row">
                                    <OKTableCell className="coverage-and-plans__table-category">
                                        <OKButton
                                            modifier="link-emphasize"
                                            onClick={this.handleToggleDetailsModal}
                                        >
                                            {formatText('insuranceRequestHome-step3ViewDetailLink')}
                                        </OKButton>
                                    </OKTableCell>
                                    {buildApplyButtons}
                                </OKTableRow>
                            </tbody>
                        </table>
                    </div>
                    <div className="visible-xs visible-sm">
                        <OKCarousel
                            settings={settings}
                            blocks={coveragesAndPlansBlock}
                            leftButtonClass="ok-carousel__left-button"
                            rightButtonClass="ok-carousel__right-button"
                            leftIcon="icon-anterior"
                            rightIcon="icon-siguiente"
                            customClass="coverage-and-plans-ok-carousel"
                        />
                    </div>
                    {this.buildDisclaimerCoverageConfigurable()}
                </div>
            </div>
        )
    }
}

InsuranceRequestPlans.propTypes = {
    immInsuranceWizardStep: PropTypes.object.isRequired,
    insuranceSelectPlan: PropTypes.func.isRequired,
    insuranceUsabilityImprovementsFlag: PropTypes.bool,
    isRelated: PropTypes.bool,
    onChangeShowCoverageDetailTable: PropTypes.func.isRequired,
    onhandleChangeSelectedPlanInStateComponent: PropTypes.func,
    recordEventSelectPlan: PropTypes.func,
    selectPlanInRelatedWizardStep3: PropTypes.func,
    setData: PropTypes.func.isRequired,
    webActuationLimitsIsEnabled: PropTypes.bool,
};

InsuranceRequestPlans.defaultProps = {
    isRelated: false,
    selectPlanInRelatedWizardStep3: () => { },
    onhandleChangeSelectedPlanInStateComponent: () => { },
    recordEventSelectPlan: () => { }
};

module.exports = InsuranceRequestPlans;

